const USER_ROLES = ["AUTHOR", "REVIEWER", "EDITOR", "PUBLISHER"];
const USER_STATUSES = ["UNRESTRICTED", "RESTRICTED", "SUSPENDED", "BANNED"];
const USER_TITLES = ["Dr.", "Prof.", "Miss.", "Mr.", "Mrs.", "Ms."];

export { USER_ROLES, USER_STATUSES, USER_TITLES };
